import Footer from '../Footer'

import brochure from '../../assets/IEEE-Flyer.jpeg'

export default function Brochure() {
  return (
    <main>
      <div className="" style={{display: 'flex',justifyContent: 'center', alignItems: 'center', eight: '100vh', paddingTop:'120px'}}>
      <img src={brochure}/>

      </div>
      <Footer />
    </main>
  );
}
